import { ColDef } from 'ag-grid-community';

export function generateColumnDefs(name: string, columnDefs: ColDef[]): ColDef[] {
    if (
        localStorage.getItem(`column-state_${name}`) &&
        JSON.parse(localStorage.getItem(`column-state_${name}`)).columns &&
        !JSON.parse(localStorage.getItem(`column-state_${name}`))?.autosize
    ) {
        const savedState = JSON.parse(localStorage.getItem(`column-state_${name}`)).columns;
        const newState = [];
        savedState.forEach(state => {
            const identifier = state.field || state.colId;
            const column = columnDefs.find(c => c.field === identifier || c.colId === identifier);
            if (column) {
                newState.push({ ...column, ...state, sort: null });
            }
        });
        return newState;
    }
    return columnDefs;
}
